<mat-card-header class="flex align-items-center">
  <shared-title
    >{{
      this.data && this.data.toEdit ? 'Editar' : 'Crear'
    }}
    Edificio</shared-title
  >
  <button
    mat-icon-button
    matTooltip="Limpiar formulario"
    matTooltipPosition="right"
    class="ml-5"
    (click)="clearForm()">
    <mat-icon>cleaning_services</mat-icon>
  </button>
</mat-card-header>

<form [formGroup]="buildingForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <shared-input
      [labelTitle]="'Nombre'"
      [control]="$any(buildingForm.get('name'))" />
    <div
      class="w-full gap-1 flex flex-column sm:flex-column md:flex-row lg:flex-row xl:flex-row">
      <shared-input
        class="w-full"
        [labelTitle]="'Código'"
        [styleText]="'uppercase'"
        [control]="$any(buildingForm.get('code'))" />

      <shared-select
        class="w-full"
        [labelTitle]="'Empresa'"
        [control]="$any(buildingForm.get('idBusiness'))"
        [options]="business()"
        [selectId]="'idBusiness'" />
    </div>
    <shared-text-area
      [labelTitle]="'Dirección'"
      [control]="$any(buildingForm.get('address'))" />

    <mat-label>Click en el mapa para seleccionar la ubicación</mat-label>
    <div
      class="w-full sm:w-full md:w-0 md:w-0 lg:w-0 xl:w-0"
      id="map"
      (click)="openMapModal()"
      #map></div>
  </mat-dialog-content>
  <mat-dialog-actions class="w-full gap-2 flex justify-content-evenly mb-3">
    <shared-button
      mat-dialog-close
      [icon]="'clear'"
      [typeBtn]="'button'"
      [color]="'warn'">
      Cancelar
    </shared-button>
    <shared-button
      [disabled]="!buildingForm.valid"
      [icon]="'save_alt'"
      [typeBtn]="'submit'"
      [color]="'accent'">
      Guardar
    </shared-button>
  </mat-dialog-actions>
</form>
